import { bootup } from '../../api/Endpoints';
import { QUERY_KEYS } from '../../api/config';
import { GetInitData } from './BootupModel';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useGetInitData = () => {
  const queryClient = useQueryClient();

  return useQuery<GetInitData>({
    queryKey: [QUERY_KEYS.INIT_DATA],
    queryFn: async () => {
      try {
        const response = await bootup.getInitData();
        return response.data;
      } catch (e) {
        const cachedData = queryClient.getQueryData([QUERY_KEYS.INIT_DATA]);
        if (cachedData) {
          return cachedData;
        }
        throw e;
      }
    },
    staleTime: 0,
  });
};
